import React from 'react'

export const sponsorAppData =[
     {
    id:1,
    name: "Mangocash",
    icon: "https://play-lh.googleusercontent.com/1zaoE6HKaD1MeiE1yeXAv8jZMURkWWppI4sel2mlptq53oG8DzQoObH32CDWvWJaVKo=w480-h960-rw",
    des:"Complete task,and collect more coins",
    link:"https://play.google.com/store/apps/details?id=com.mangocash.moon&hl=en_IN",
    coins:2400,
    dateTime:"30 October 2025, 01:56 PM"
  }, {
    id:2,
    name: "Panda King",
    icon: "https://play-lh.googleusercontent.com/9xx1s7ESCnDjYtk7dgB3wki8NpwF_scpCmx0xy9UHiGYK9Dvs_NUYFSWfUWu8MC84Xz7L8RMz-WAHkDDoJ1BTAs=w480-h960-rw",
    des:"Complete task,and collect more coins",
    link:"https://play.google.com/store/apps/details?id=com.appnova.pandaking&hl=en_IN",
    coins:2200,
    dateTime:"30 October 2025, 01:56 PM"
  },
];
